module.exports = __webpack_public_path__ + "static/media/twitter-x-red.000255dc.svg";